import { render, staticRenderFns } from "./MessageUrlIntent.vue?vue&type=template&id=1f96fee6"
import script from "./MessageUrlIntent.vue?vue&type=script&lang=js"
export * from "./MessageUrlIntent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports